import React, { useState, useEffect, useRef } from 'react';
import {
  PlacesProvider,
  getExcludes,
  getChilds,
  Autocomplete,
  nearestTownRest,
} from '@atresmedia/elections_modules_library';
import { getRoute, getParams } from '../../utils';

const MODES = {
  MANUAL: 'manual',
  CERCANOS: 'cercanos',
  HIJOS: 'hijos',
};

const CopyBox = ({ buttonText, children, className }) => {
  const elementRef = useRef();
  return (
    <div className={className}>
      <pre className="border scroll" ref={elementRef}>
        {children}
      </pre>
      <button
        className="button  fixed-btn"
        onClick={(el) => {
          const range = document.createRange();
          range.selectNodeContents(elementRef.current);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          document.execCommand('copy');
          sel.removeRange(range);
        }}
      >
        {buttonText}
      </button>
    </div>
  );
};

const ButtonGenerator = ({
  electionType,
  parentPlace,
  year,
  electionNumber,
}) => {
  const [mode, setMode] = useState(MODES.MANUAL);
  const [autocomplete, setAutocomplete] = useState('');
  const [excludes, setExcludes] = useState(null);
  const [places, setPlaces] = useState([]);

  useEffect(() => {
    const { community } = getParams(parentPlace);

    // Get new manual urls
    setExcludes(null);
    getExcludes(electionType, electionNumber, year, community).then(
      setExcludes
    );

    // Set initial selected places
    switch (mode) {
      default:
      case MODES.MANUAL: {
        setPlaces([]);
        break;
      }
      case MODES.CERCANOS: {
        if (parentPlace.location) {
          nearestTownRest(
            parentPlace.ineId,
            parentPlace.location.lat,
            parentPlace.location.lon
          ).then(({ data = {} }: response) => {
            const places = data.content || [];
            setPlaces(
              places.filter(
                (place) => place.grandpaId === parentPlace.grandpaId
              )
            );
          });
        } else {
          setPlaces([]);
        }
        break;
      }
      case MODES.HIJOS: {
        getChilds(
          parentPlace.typePlace === 'REGION' ? 'PROVINCE' : 'TOWN',
          parentPlace.ineId
        ).then((data = {}) => setPlaces(data.content || []));
        break;
      }
    }
  }, [electionType, electionNumber, year, parentPlace, mode]);

  const addPlace = (place) => {
    setAutocomplete('');
    if (!places.find((p) => p.ineId === place.ineId)) {
      setPlaces([...places, place]);
    }
  };

  const removePlace = (place) => {
    setAutocomplete('');
    setPlaces(places.filter((item) => item.ineId !== place.ineId));
  };

  return (
    <div className="containerel">
      <div className="flex-container ">
        <div className="flex-row center">
          <button
            className={`button-gen ${mode === MODES.MANUAL && 'selected'}`}
            onClick={() => setMode(MODES.MANUAL)}
          >
            Manual
          </button>
          {parentPlace && parentPlace.typePlace === 'TOWN' ? (
            <button
              className={`button-gen ${mode === MODES.CERCANOS && 'selected'}`}
              onClick={() => setMode(MODES.CERCANOS)}
            >
              Cercanos
            </button>
          ) : (
            <button
              className={`button-gen ${mode === MODES.HIJOS && 'selected'}`}
              onClick={() => setMode(MODES.HIJOS)}
            >
              Hijos
            </button>
          )}
        </div>
        {mode === MODES.MANUAL && (
          <div className="flex-row center">
            {electionType !== 'REGIONAL' && (
              <div className="m10 w200">
                <PlacesProvider name={parentPlace.name} type="REGION">
                  {(data) => (
                    <Autocomplete
                      results={data}
                      onChange={setAutocomplete}
                      onSelect={addPlace}
                      placeholder="Busque CCAA"
                      showArrow
                    />
                  )}
                </PlacesProvider>
              </div>
            )}

            <div className="m10 w200">
              <PlacesProvider
                name={autocomplete}
                type="PROVINCE"
                parentId={parentPlace.ineId}
              >
                {(data) => (
                  <Autocomplete
                    results={data}
                    onChange={setAutocomplete}
                    onSelect={addPlace}
                    placeholder="Busque provincia"
                    showArrow
                  />
                )}
              </PlacesProvider>
            </div>
            <div className="m10 w200">
              <PlacesProvider
                name={autocomplete}
                type="TOWN"
                grandParentId={
                  parentPlace.typePlace === 'REGION' ? parentPlace.ineId : ''
                }
                parentId={
                  parentPlace.typePlace === 'REGION' ? '' : parentPlace.ineId
                }
              >
                {(data) => (
                  <Autocomplete
                    results={data}
                    onChange={setAutocomplete}
                    onSelect={addPlace}
                    placeholder="Busque municipio"
                    showArrow
                  />
                )}
              </PlacesProvider>
            </div>
          </div>
        )}

        <div className="row">
          <div className="w20 mh left list">
            <ol className="border">
              {places.map((place) => (
                <li key={place.ineId}>
                  <p>
                    <button
                      className="button"
                      onClick={() => removePlace(place)}
                    >
                      X
                    </button>
                    {place.name}
                  </p>
                </li>
              ))}
            </ol>
          </div>
          <CopyBox className="w20 mh left" buttonText="Copiar">
            {
              '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
            }
            {places.map(
              (
                place
              ) => `<li><a class="tags-list__link btn btn-secondary" title="${
                place.ineId
              }" href="${getRoute(place, true, excludes, 1)}" > ${
                place.name
              } </a></li>
`
            )}
            {'</ul></div>'}
          </CopyBox>
          <CopyBox className="w20 mh left" buttonText="Copiar AMP">
            {
              '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
            }
            {places.map(
              (
                place
              ) => `<li><a class="tags-list__link btn btn-secondary" title="${
                place.ineId
              }" href="${getRoute(place, true, excludes, 1).replace(
                'www.',
                'amp.'
              )}" > ${place.name} </a></li>
`
            )}
            {'</ul></div>'}
          </CopyBox>
          <div className="w40 mh left border">
            {places.map((place) => (
              <a
                key={place.ineId}
                href={getRoute(place, true, excludes, 1)}
                type="button"
                className="tag"
              >
                {place.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonGenerator;
